import React, { useContext } from "react";
import styled from "styled-components";
import image from "assets/images/andres.jpeg";
import { Title } from "components/Typography";
import { LanguageContext } from "contexts/language.context";
import { Translate } from "utils/translate";

const Container = styled.div`
  width: 100%;
`;

const Grid = styled.div`
  @media only screen and (max-width: 800px) {
    display: flex;
    flex-direction: column-reverse;
    img {
      margin-bottom: 4rem;
    }
  }
  @media only screen and (min-width: 801px) {
    display: grid;
    grid-template-columns: 50% 40%;
    grid-gap: 10%;
  }

  img {
    width: -webkit-fill-available;
  }
`;

const Bio = () => {
  const { language } = useContext(LanguageContext);
  return (
    <Container>
      <Title variant="h5">{Translate(language, ["BIO", "title"])}</Title>
      <Grid>
        <div>{Translate(language, ["BIO", "data"])}</div>
        <div>
          <img src={image} />
        </div>
      </Grid>
    </Container>
  );
};

export default Bio;
